import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SeoService } from '../../../service/seo.service';

@Component({
    selector: 'app-startup-nuove-imprese',
    templateUrl: './startup-nuove-imprese.component.html',
    standalone: false
})
export class StartupNuoveImpreseComponent implements OnInit {

    constructor(private router: Router, private seoService: SeoService) { }

    ngOnInit(): void {
        const h2Text = "Incentivi per startup innovative e nuove imprese: finanziamenti a tasso zero (ON), bandi Smart&Start, fondi PNRR per imprese giovanili / femminili";
        
        this.seoService.updateSeo({
            titleSeo: "Bandi Startup & Nuove Imprese – PMI | Innovation Plaza",
            metadescription: h2Text
        });
    }

    goTo(route: string){		 
        this.router.navigate([route])
    }

}